import React from 'react'
import LastNew from './LastNew'

function LastNews() {
  return (
    <div className='lastnews'> 
      <LastNew/>      
      <LastNew/>      
      <LastNew/>  
      <LastNew/>      
      <LastNew/>      
      <LastNew/>       
    </div>
  )
}

export default LastNews
